import { TeamResultStatus } from 'screens/Protection/protection.types'

export const protectionStatusMap: Record<TeamResultStatus, string> = {
  not_started: 'Не начато',
  in_progress: 'В процессе',
  completed: 'Завершено',
  failed: 'Не выполнено',
}

export const protectionStatus = (status: TeamResultStatus) => protectionStatusMap[status]
